// extracted by mini-css-extract-plugin
export default {"contentStyle":"contentStyle--JgmMC","content":"content--DuBRt","container":"container--uZG4J","header":"header--TfMSn","title":"title--ukEQ1"};